export const fullReload = () => {
  window.location.href = `${window.location.href}?reload=true`
}
